export class Regions {
    static IAD_REGION = 'us-east-1'
    static PDX_REGION = 'us-west-2'
}
